import React, { useEffect, useState } from "react";
import CustomizedDialogs from "../../../common/CustomizedDialogs";
import { Box, Divider } from "@mui/material";
import CustomDatePicker from "../../../common/CustomDatePicker";
import DropDownV3 from "../../../common/DropDownV3";
import MButton from "../../../common/MButton";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { showErrorAlert } from "../../../redux/Actions";
import { getOperatorListData } from "../../../redux/Report/ReportActions";
import { agentTransType } from "../constants";
import { encryptText } from "../../../utils/encrypt";

const AgentTransactionsModal = (props) => {
  const { open = false, titleText = "", onClose = () => { } } = props;
  const dispatch = useDispatch();
  const store = useSelector((store) => store);
  const { user } = store;
  const { userDetails } = user;

  const [filterValue, setFilterValue] = useState({
    operators: [],
    types: [agentTransType[0]],
    toDate: dayjs(),
    fromDate: dayjs(),
  });
  const [filterOpt, setFilterOpt] = useState({
    operators: [],
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const operatorProps = () => {
    return {
      width: "100%",
      name: "operator",
      id: "operator",
      label: "Operator",
      isCompulsory: false,
      options: filterOpt.operators || [],
      preSelectedValues: filterValue.operators || [],
      searchPlaceholder: "Search by Operator",
      disabled: false,
      isObject: true,
      primaryKey: "CompanyID",
      labelKey: "CompanyName",
      singleSelect: true,
      selectAllOption: true,
      defaultAllSelected: true,
      nextId: "",
      prevId: "",
    };
  };
  const typeProps = () => {
    return {
      width: "100%",
      name: "type",
      id: "type",
      label: "Type",
      isCompulsory: false,
      options: agentTransType || [],
      preSelectedValues: filterValue.types || [],
      searchPlaceholder: "Search by Type",
      disabled: false,
      isObject: true,
      primaryKey: "TypesID",
      labelKey: "TypesName",
      singleSelect: true,
      selectAllOption: false,
      defaultAllSelected: false,
      nextId: "",
      prevId: "",
    };
  };
  useEffect(() => {
    // if (userDetails?.AgentID) {
    fetchAgentList();
    // }
  }, [userDetails?.AgentID, userDetails?.AgentUserID]);
  const fetchAgentList = () => {
    const body = {
      intAgentUserID: userDetails?.AgentUserID,
      intAgentID: userDetails?.AgentID,
    };
    dispatch(getOperatorListData(body)).then((res) => {
      if (res.data.status) {
        const parsedData = JSON.parse(res.data.Data);
        const table = parsedData?.Table || [];
        setFilterOpt((prev) => ({
          ...prev,
          operators: table || [],
        }));
        setFilterValue((prev) => ({
          ...prev,
          operators: table || [],
        }));
        setIsModalVisible(true);
      } else {
        dispatch(showErrorAlert(res.data.Message));
      }
    });
  };
  return (
    <CustomizedDialogs
      open={open && isModalVisible}
      titleText={titleText}
      width={"450px"}
      height={"auto"}
      onClose={onClose}
      padding={"0px"}
    >
      <Box
        sx={{
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Box className="date_pickerV40">
          <CustomDatePicker
            label="From Date"
            id="journey_Date"
            selectedDate={filterValue.fromDate}
            onChange={(date) => {
              if (new Date(date) < new Date(filterValue.toDate)) {
                setFilterValue({ ...filterValue, fromDate: date })
              } else {
                setFilterValue({ ...filterValue, fromDate: date, toDate: date })
              }
            }}
            minDate={null}
          />
        </Box>
        <Box className="date_pickerV40">
          <CustomDatePicker
            label="To Date"
            id="journey_Date"
            selectedDate={filterValue.toDate}
            onChange={(date) => {
              setFilterValue((prev) => ({
                ...prev,
                toDate: date,
              }));
            }}
            minDate={filterValue.fromDate}
          />
        </Box>

        <Box>
          <DropDownV3
            {...operatorProps()}
            onSelect={(val) => {
              setFilterValue((prev) => ({
                ...prev,
                operators: val,
              }));
            }}
          />
        </Box>
        <Box>
          <DropDownV3
            {...typeProps()}
            onSelect={(val) => {
              setFilterValue((prev) => ({
                ...prev,
                types: val,
              }));
            }}
          />
        </Box>
      </Box>
      <Divider sx={{ borderColor: "#cccccc" }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          gap: "8px",
          padding: "12px 16px",
        }}
      >
        <MButton
          variant="outlined"
          btnName="Close"
        // onClick={onClose}
        />
        <MButton
          btnName="Generate"
          onClick={() => {
            const params = {
              fromDate: filterValue.fromDate.format("YYYY-MM-DD"),
              toDate: filterValue.toDate.format("YYYY-MM-DD"),
              operatorID: filterValue.operators.length === 1 ? filterValue.operators?.[0].CompanyID : 0,
              operator: filterValue.operators.length === 1 ? filterValue.operators?.[0].CompanyName : "ALL Operator",
              typeID: filterValue.types.length === 1 ? filterValue.types?.[0].TypesID : 0,
              type: filterValue.types.length === 1 ? filterValue.types?.[0].TypesName : "ALL Type",
              intAgentUserID: userDetails?.AgentUserID,
              intAgentID: userDetails?.AgentID,
            }
            window.open(`/agentTxnsReport?data=${encodeURIComponent(encryptText(JSON.stringify(params)))}`, "_blank");
          }}
        />
      </Box>
    </CustomizedDialogs>
  );
};

export default AgentTransactionsModal;
